import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import type { LearnDeckContextValue } from "#learn-deck-context-value";

export const LearnDeckContext = createContext(
  defaultError<LearnDeckContextValue>("LearnDeckContext"),
);
